export const COLUMN_WIDTHS = {
  ACCOUNT: 200,
  ACTIONS: 115,
  CREATED_ON: 125,
  CUSTOMER_SUCCESS: 150,
  DESIGNATION: 120,
  EMAIL: 250,
  NAME: 280,
  RATING: 150,
  ROLE: 150,
  TEAM: 150,
};
